module.exports = __webpack_public_path__ + "img/home2_2x.f555bad5.png";